var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCursorClick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.cursor-click{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cursor-click",
    d: "M4.8,4.8L9,15.2l1.2-5l5-1.2L4.8,4.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cursor-click",
    d: "M11,11l4.2,4.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cursor-click",
    d: "M0.8,0.8l1.5,1.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cursor-click",
    d: "M9.2,0.8L7.8,2.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cursor-click",
    d: "M13.8,13.8l1.5,1.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cursor-click",
    d: "M2.2,7.8L0.8,9.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorClick);
export default __webpack_public_path__ + "static/media/cursor-click.d5eaefcefd07b1e1d45721a7130ff9b3.svg";
export { ForwardRef as ReactComponent };